import { getUsers, teacherGetMyAttendanceByMonth, updateProfile, getMySchoolAccess, toggleSchoolAccess } from '../../../services/UserService.js';
import { getUserSubscriptions, requestFreezeService } from '../../../services/SubscriptionService.js';

export default {
    async loadUsers(context) {
        const schoolId = context.rootGetters['school/getSchoolId'];
        const allUsers = await getUsers(
            context.rootGetters['auth/getToken'],
            schoolId || null,
        );
        context.commit('setAllUsers', allUsers.data.users);
    },
    async teacherGetMyAttendancebyMonth(context) {
        const schedule = await teacherGetMyAttendanceByMonth(context.rootGetters['auth/getToken']);
        context.commit('teacherSetMyAttendanceByMonth', schedule.data);
    },
    async updateProfile(context, payload) {
        const updatedProfile = await updateProfile(context.rootGetters['auth/getToken'], payload);
        context.dispatch('auth/saveDataUserAfterUpdateProfile', {user: updatedProfile.data.user}, {root: true});
    },
    async fetchMySchoolAccess(context) {
        const response = await getMySchoolAccess(context.rootGetters['auth/getToken']);
        context.commit('setSchoolAccessList', response.data.schoolAccess);
    },
    async toggleSchoolAccess(context, schoolId) {
        const response = await toggleSchoolAccess(context.rootGetters['auth/getToken'], schoolId);
        context.commit('updateSchoolAccessEntry', response.data);
    },
    async fetchMySubscriptions(context) {
        const userId = context.rootGetters['auth/getCurrentUserId'];
        const response = await getUserSubscriptions(userId, context.rootGetters['auth/getToken']);
        context.commit('setMySubscriptions', response.data.subscriptions);
    },
    async requestFreeze(context, { subId, description }) {
        const userId = context.rootGetters['auth/getCurrentUserId'];
        await requestFreezeService(userId, subId, description, context.rootGetters['auth/getToken']);
        await context.dispatch('fetchMySubscriptions');
    }
}